import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import './plugins/axios'
import router from './router/router'
import store from './store/store'
import moment from 'moment'
import jwt from 'jsonwebtoken'

Vue.config.productionTip = false

Vue.prototype.moment = moment; // https://stackoverflow.com/questions/34308004/moment-js-with-vuejs
Vue.prototype.jwt = jwt;

import 'vuetify/dist/vuetify.min.css'

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')

window.addEventListener('storage', (evt) => {
    // console.log(evt);
    if (evt.key === 'user-token' && evt.oldValue === store.getters.token) {

        if (!evt.newValue || evt.oldValue !== evt.newValue) {
            // console.log("dispatching logout...")
            store.dispatch("logout");
            router.push('login');
        }
        // console.log(`LOCALSTORAGE CHANGED - ${evt.key} - ${evt.oldValue} -> ${evt.newValue}`);
    }
});

var originalSetItem = localStorage.setItem;
localStorage.setItem = function () {
    var event = new Event('itemInserted');
    event.key = arguments[0];
    event.newValue = arguments[1];
    window.dispatchEvent(event);
    originalSetItem.apply(this, arguments);
};

var originalRemoveItem = localStorage.removeItem;
localStorage.removeItem = function () {
    var event = new Event('itemRemoved');
    event.key = arguments[0];
    window.dispatchEvent(event);
    originalRemoveItem.apply(this, arguments);
};

var originalClear = localStorage.clear;
localStorage.clear = function () {
    var event = new Event('clearItems');
    window.dispatchEvent(event);
    originalClear.apply(this, arguments);
}

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg, vm, trace) {
  // `trace` is the component hierarchy trace
  if (msg.includes(ignoreWarnMessage) && vm && trace) {
    msg = null;
    vm = null;
    trace = null;
  }
}